import { render, staticRenderFns } from "./VersionNoPage.vue?vue&type=template&id=39eb5fb6&scoped=true";
import script from "./VersionNoPage.vue?vue&type=script&lang=js";
export * from "./VersionNoPage.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "39eb5fb6", null);
export default component.exports;